<h1>Counter</h1>

<p>This is a simple example of an Angular component.</p>

<p>
  Current count: <strong>{{ currentCount }}</strong>
</p>

<button (click)="incrementCounter()">Increment</button>
